import { environmentHttpClient as httpClient } from "client/Api/httpClient";

export type ServiceTicketListItem = {
	id: number;
	title: string;
	status: string;
	dateCreated: string | null;
};

export type ListServiceTicketsResponse = {
	items: ServiceTicketListItem[];
	hasMore: boolean;
};

export type AddAttachmentModel = {
	ticketId: number;
	file: File;
};

export function list(): Promise<ListServiceTicketsResponse> {
	return httpClient.get<ListServiceTicketsResponse>("Workspace/LiveInformation/ConnectWise");
}

export type CreateTicketModel = {
	title: string;
	description: string;
};

export function createTicket(
	model: CreateTicketModel,
	signal?: AbortSignal
): Promise<ServiceTicketListItem> {
	return httpClient.post<ServiceTicketListItem>(
		"Workspace/LiveInformation/ConnectWise/Tickets",
		model,
		{
			signal
		}
	);
}

export function deleteTicket(id: number, signal?: AbortSignal): Promise<void> {
	return httpClient.delete<void>(
		`Workspace/LiveInformation/ConnectWise/Tickets/${id}`,
		undefined,
		{
			signal
		}
	);
}

export function addAttachment(
	model: AddAttachmentModel,
	signal?: AbortSignal
): Promise<void> {
	const formData = new FormData();
	formData.append("File", model.file);
	formData.append("ticketId", model.ticketId.toString());

	return httpClient.postFormData<void>(
		"Workspace/LiveInformation/ConnectWise/Attachments",
		formData,
		{
			signal
		}
	);
}
